import React from 'react';
import Button from '../../elements/Button/Button';
import { ico_arrow_left, ico_bars } from '../../icon';
import Stylesheet from './Navigation.module.css';
import Classnames from 'classnames';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../contexts/app';

const Navigation = (props) => {
    const history = useHistory();
    const location = useLocation();
    /**
     * @returns {Array<Any>}
     */
    const breadCrumbs = () => {
        const currentURL = location.pathname;
        // get individual crumbs
        const crumbs = currentURL.split('/');
        // attach previous crumbs
        for (let index = 1; index < crumbs.length; index++) {
            if (index > 1) crumbs[index-1] = `${crumbs[index-2]
                .link}/${crumbs[index]}`;
            else crumbs[index-1] = `/${crumbs[index]}`;
            let text = crumbs[index];
            // show only 2 top level crumbs and minimize the rest
            if (crumbs.length > 2 
                && index < crumbs.length - 2) 
                text = '....';
            else {
                const length = text.replaceAll('-',' ')
                    .split(' ').length;
                if (length > 3) 
                    text = text.replaceAll('-',' ')
                    .split(' ').slice(0,3).join(' ')+'....';
            }
            crumbs[index-1] = {
                link: `${crumbs[index-1]}`,
                value: text
            };
        }
        crumbs.pop();
        return crumbs;
    }

    return (
        <AppContext.Consumer>
            {app => (
                <div className={Classnames(Stylesheet.Container)}>
                    <div className={Stylesheet.Menu} 
                    onClick={_ => app.toggleMenu()}>
                        <h3>{ico_bars}</h3>
                    </div>
                    <div className={Stylesheet.Button}>
                        <Button onClick={history.goBack} title='back'
                        icon minimal>{ico_arrow_left}</Button>
                    </div>
                    <div className={Stylesheet.Breadcrumbs}>
                        {breadCrumbs().map((crumb, index) => (
                            <React.Fragment key={index}>
                                <h5 className={Classnames(Stylesheet.Crumb,
                                index === 0 ? Stylesheet.Page : null)}>
                                    {index === 0 
                                    ? crumb.value.replaceAll('-', ' ') 
                                    : <Link to={`${crumb.link}`}>
                                    {crumb.value.replaceAll('-', ' ')}</Link>}
                                </h5>&nbsp;/&nbsp;
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )}
        </AppContext.Consumer>
    )
}

export default Navigation;